// extracted by mini-css-extract-plugin
export var billingAddress = "_yh-g";
export var contactInfo = "_yh-d";
export var customerInfoContainer = "_yh-c";
export var customerInfoContainerMobile = "_yh-h";
export var customerInfoRow = "_yh-a";
export var customerInfoSection = "_yh-b";
export var fullWidthDividerMobile = "_yh-i";
export var imageContainer = "_yh-1";
export var paymentMethod = "_yh-e";
export var priceText = "_yh-6";
export var priceTextMobile = "_yh-7";
export var product = "_yh-0";
export var productImage = "_yh-2";
export var productInfo = "_yh-4";
export var productMobile = "_yh-9";
export var productTitle = "_yh-8";
export var quantityBadge = "_yh-3";
export var quantityText = "_yh-5";
export var shippingAddress = "_yh-f";